import { FC } from "react"

import Text from "components/Text/Text"

interface IInfoDropdownHeaderProps {
    title: string
}

const InfoDropdownHeader: FC<IInfoDropdownHeaderProps> = ({
    title,
}) => {
    return (
        <Text type="pSmallest" className="pt-2 px-2 pb-1 font-bold color-grey-600 border-bottom-grey-100">
            {title}
        </Text>
    )
}

export default InfoDropdownHeader
